import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { CustomerLegalFormService } from "../../core/service/customer-legal-form.service";
import { CustomerLegalForm } from "../../core/model/customer-legal-form";

@Component({
  selector: "app-edit-legal-form",
  templateUrl: "./edit-legal-form.component.html",
  styleUrls: ["./edit-legal-form.component.scss"],
})
export class EditLegalFormComponent implements OnInit {
  pressButton: Boolean = false;
  form: FormGroup;

  legalFormId: number;
  customerLegalForm: CustomerLegalForm;

  constructor(
    private _router: Router,
    private _customerLegalFormService: CustomerLegalFormService,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      label: [
        "",
        [Validators.compose([Validators.required]), Validators.maxLength(50)],
      ],
    });
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.legalFormId = params["legalFormId"];
      this.getCustomerLegalForm(this.legalFormId);
    });
  }

  getCustomerLegalForm(legalFormId) {
    this._customerLegalFormService
      .getCustomerLegalFormById(legalFormId)
      .subscribe(
        (data) => {
          this.customerLegalForm = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  save(): void {
    this._customerLegalFormService
      .update(this.customerLegalForm)
      .pipe(first())
      .subscribe(
        (data) => {
          this._router.navigateByUrl("/parametrage/legal-form");
        },
        (error) => {
          console.log(error);
        }
      );
  }

  cancel(): void {
    this._router.navigate(["/parametrage/legal-form"]);
  }
}
